import { handleActions } from 'redux-actions'

import {
  SET_WIDGETS,
} from './widgets.action'

import { LOGOUT } from '../../actions'

const initialState = {
  customMetrics: {
    data: [],
  },
}

export default handleActions({
  [SET_WIDGETS]: (state, action) => ({
    ...state,
    customMetrics: {
      ...state.customMetrics,
      data: action.payload,
    },
  }),
  [LOGOUT]: () => initialState,
}, initialState)
